import { DESKTOP_BREAKPOINT_WIDTH_HEADER } from 'constants/styled.contants';
import styled, { css } from 'styled-components';

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.text.neutral.default};
  `}
`;

export const BloquedTextWrapper = styled.p`
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  display: inline;
`;

export const TotalTruckersWrapper = styled.div<{ $hasLockedDrivers: boolean }>`
  ${({ theme, $hasLockedDrivers }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacing.km3};

    fuel-typography {
      p {
        text-transform: uppercase;
        white-space: nowrap;
      }
    }

    ${$hasLockedDrivers &&
    css`
      align-items: center;

      @media (min-width: ${theme.breakpoint.md.maxWidth}) and (max-width: ${DESKTOP_BREAKPOINT_WIDTH_HEADER}) {
        margin-top: -24px;
      }
    `}
  `}
`;
